import { useState } from "react";
import { FileUpload } from "../../shared/FileUpload";
import { fileNameToDocName, isValidDocName } from "./state";

interface Props {
  docName: string;
  initialContent: string;
  busy: boolean;
  onChange: (patch: { docName?: string; initialContent?: string }) => void;
  onStart: () => void;
}

export function Step1Input({ docName, initialContent, busy, onChange, onStart }: Props) {
  const [showError, setShowError] = useState(false);

  function handleStart() {
    if (!isValidDocName(docName)) {
      setShowError(true);
      return;
    }
    setShowError(false);
    onStart();
  }

  function appendContent(md: string, fileName: string) {
    const next = initialContent ? initialContent + "\n\n" + md : md;
    onChange({ initialContent: next });
    if (!docName.trim()) {
      const suggested = fileNameToDocName(fileName);
      if (suggested) onChange({ docName: suggested });
    }
  }

  return (
    <section className="wizard-section" data-custom-step="1">
      <h2 className="form-title">Eigenes Dokument</h2>
      <p className="form-description">
        Füge deinen Text ein oder lade eine Datei hoch. Anschließend kannst du das Dokument
        im Chat mit KI bearbeiten und als DOCX oder PDF exportieren.
      </p>
      <div className="form-row">
        <label htmlFor="custom-doc-name">Dokumentname *</label>
        <input
          id="custom-doc-name"
          type="text"
          autoComplete="off"
          placeholder="z. B. angebot_musterfirma"
          value={docName}
          onChange={(e) => {
            onChange({ docName: e.target.value });
            if (showError) setShowError(false);
          }}
        />
        <span className="field-hint">
          Wird als Dateiname verwendet. Nur Buchstaben, Zahlen und Unterstriche.
        </span>
        {showError && (
          <span className="field-error-msg">
            Bitte einen gültigen Namen eingeben (Buchstaben, Zahlen, Unterstriche).
          </span>
        )}
      </div>
      <div className="form-row form-row-full">
        <label htmlFor="custom-doc-input">Dokumentinhalt (Markdown)</label>
        <textarea
          id="custom-doc-input"
          rows={12}
          placeholder="Markdown-Text hier einfügen, oder Datei hochladen…"
          style={{ fontFamily: "monospace", fontSize: "0.85rem" }}
          value={initialContent}
          onChange={(e) => onChange({ initialContent: e.target.value })}
        />
        <FileUpload
          hint="oder Datei hochladen (PDF, DOCX, TXT, MD) — wird zu Markdown konvertiert"
          onConverted={(md, name) => appendContent(md, name)}
        />
      </div>
      <div className="form-actions">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleStart}
          disabled={busy}
        >
          {busy ? "Erstelle Dokument…" : "Weiter →"}
        </button>
      </div>
    </section>
  );
}
